<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addRecord, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-import(model="purchase_order_details")
    .container-fluid
      vm-row.heading(vm-w="12")
        vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
          div
            h2 {{ $t('strings.purchase_order_details') }}:
            span {{ $t('strings.description', {attribute: $t('strings.purchase_order_details')}) }}
          div(style="display:none;")
            vm-button(type="default" icon="list")
            vm-button(type="default" icon="grid" color="rgba(var(--gray),1)")
      vm-row(vm-w="12")
        vm-col.card(vm-sm=12)
          vm-table(v-model="selected"  max-height="350px" :data="purchaseOrderDetails")
            template(slot="thead")
              vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('purchase_order_details.' + column) }}
            template(slot-scope="{data}")
              vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                  slot(v-if="column == 'total' || column == 'price' || column == 'subtotal'")  {{data[indextr][column] | currency()}}
                  slot(v-if="column == 'created_at'")  {{data[indextr][column] | moment("DD MMMM YYYY") }}
                  slot(v-if="column == 'quantity' || column == 'active_shipment_quantity' || column == 'pending_amount_to_ship' || column == 'pending_amount_to_be_received'") {{ data[indextr][column] | currency('') }}
                  slot(v-if="column == 'product_code_display' || column == 'product_display'") {{data[indextr][column]}}
                  vm-status-indicator(v-if="column == 'status_id'" :pulse="data[indextr]['status_id'] !== 'Activo'" :color="colorStatus(data[indextr]['status_id'])") {{ $t('purchase_order_details.'+ data[indextr]['status_id']) }}
                vm-td
                vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                  vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")
                  vm-dropdown-menu
                    vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['status_id'] != 'discarded' && $auth.check(['Admin'])" @click="setActionRecord(data[indextr], 'discard')")
                      vm-icon(icon="checkmark-circle-outline")
                      slot &nbsp;{{ $t('purchase_order_details.discard_product') }}
</template>

<script>
import ViewMixinMaster2 from '@/mixins/ViewMixinMaster2'
import { createNamespacedHelpers, mapGetters as configMapGetters } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrderDetails')
const ModalImport = () => import('@/components/modals/ModalImport.vue')

export default {
  name: 'PurchaseOrderDetails',
  components: {
    ModalImport
  },
  mixins: [ViewMixinMaster2],
  data: () => ({
    columns: [
      'product_code_display',
      'product_display',
      'quantity',
      'active_shipment_quantity',
      'pending_amount_to_ship',
      'pending_amount_to_be_received',
      'price',
      'total',
      'subtotal',
      'status_id'
    ],
    columnsOrderBy: ['product_code_display', 'product_display'],
    attributeModal: 'product_code_display',
    status: [
      {
        value: 1,
        color: 'warning'
      },
      {
        value: 2,
        color: 'danger'
      },
      {
        value: 3,
        color: 'danger'
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 49
      where: {
        product: {
          code: '',
          description: ''
        },
        quantity: '',
        price: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    }
  }),
  computed: {
    ...configMapGetters(['isSFS', 'isHMM']),
    ...mapGetters(['purchaseOrderDetails', 'catalog'])
  },
  async created () {
    await this.loadData()
  },
  methods: {
    ...mapActions([
      'updateRecord',
      'deleteRecord',
      'deleteRecords',
      'loadDetails',
      'loadCatalog',
      'actionRecord',
      'setModalVisible',
      'setModalImportVisible',
      'exportRecords',
      'applyFilter',
      'clearFilter',
      'updateQuantities',
      'checkBalanceByOrder'
    ]),
    async loadData () {
      await this.loadDetails({ id: this.$route.params.id, page: 1 }).then(() => {
        this.updateQuantities({ details: this.purchaseOrderDetails }).then(() => {
          this.checkBalanceByOrder(this.purchaseOrderDetails).then(() => {
            this.loadDetails({ id: this.$route.params.id, page: 1 })
          })
        })
      })
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.con-tablex.vm-table--content {
  overflow: visible !important;
}
thead.vm-table--thead-table {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: white;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1) {
    width: 100%;
  }
  .input-select-con {
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
</style>
